export default "__VITE_ASSET__C8DPuhdC__"